import { useHover } from '@elotech/components';
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';

const MenuItem = ({
  getIsHover,
  route,
  caption,
  image,
  itemType,
  isExternal,
  onClickMenuItem,
  location
}) => {
  const [refHover, isHover] = useHover();

  useEffect(() => {
    getIsHover(isHover);
  }, [getIsHover, isHover]);

  const classNameItem = itemType === 'father' ? itemType : 'child';

  if (isExternal) {
    return (
      <li key={route}>
        <a href={route} target="_blank" rel="noopener noreferrer">
          <i className={classnames(image, classNameItem)} />
          <b>{caption}</b>
        </a>
      </li>
    );
  }

  const classnameLi = classnames({
    on: location.pathname === route
  });

  return (
    <li ref={refHover} key={route} className={classnameLi}>
      <Link to={route} onClick={onClickMenuItem}>
        <i className={classnames(image, classNameItem)} />
        <b>{caption}</b>
      </Link>
    </li>
  );
};

export default withRouter(MenuItem);
